import React, { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";

/* Touch/mouse signature pad → PNG data URL via onChange(dataUrl|null). */
export default function SignaturePad({ onChange, label, clearLabel }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current; const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = 200 * ratio;
    const ctx = c.getContext("2d"); ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); const p = e.touches ? e.touches[0] : e; return [p.clientX - r.left, p.clientY - r.top]; };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange?.(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange?.(null); };

  return (
    <div className="space-y-2" data-testid="signature-pad">
      <div className="relative rounded-xl border-2 border-dashed border-border bg-white overflow-hidden touch-none">
        <canvas ref={ref} className="w-full h-[200px] block cursor-crosshair" data-testid="signature-canvas"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {empty && <div className="absolute inset-0 grid place-items-center pointer-events-none text-sm text-slate-400">{label}</div>}
        <div className="absolute bottom-3 left-6 right-6 border-b border-slate-300 pointer-events-none" />
      </div>
      <Button type="button" variant="ghost" size="sm" onClick={clear} className="h-8 text-xs" data-testid="signature-clear"><Eraser className="h-3.5 w-3.5 mr-1" />{clearLabel}</Button>
    </div>
  );
}
